export function setProject(state, data) {
    state.project = data;
}

export function partialUpdate(state, data) {
    if(typeof data === 'object') {
        Object.keys(data).forEach((key) => {
            state.project[key] = data[key];
        })
    }
}

export function setRelationship(state, {keyProp, value}) {
    let localProject = state.project;
    localProject[keyProp] = value

    state.project = localProject;
}
